/**
 * PSM (Presión Sistémica Media) Pathology Configuration
 *
 * This file contains the complete configuration for the PSM pathology.
 * PSM shares many components with HTA (charts, reports, glossary).
 */
import { htaProtocolGlossaryData } from '../glossaryData';

export const PSM_ID = 3;

export const psmConfig = {
  id: PSM_ID,
  name: 'PSM',
  displayNameKey: 'psm', // i18n translation key

  // Feature flags - determines what features are available for this pathology
  // Available features: 
  // surveys, ecg, nutrition, howIFeel, modalities, healthBackground, medicalInformation, configParameters
  // Only include features that are enabled (presence = enabled, absence = disabled)
  features: ['hasModality', 'healthBackground', 'medicalInformation', 'glossary', 'healthData'],

  components: {
    medicalInfoForm: 'ModifyMedicalInformationPSM',
  },

  dashboard: {
    glossaryData: htaProtocolGlossaryData, // PSM uses HTA glossary
    columnSet: 'hta-protocol', // PSM uses HTA Protocol columns
    exportFields: [
      'fullname',
      'antiquity',
      'weight',
      'measurement_dates',
      'count_measurements',
      'bp_morning_average',
      'bp_afternoon_average',
      'bp_weekly_average',
      'hr_morning_afternoon',
      'hr_general_average',
    ],
    exportTransformer: (row, t) => [
      row.fullname,
      row.antiquity,
      row.weight ? row.weight : '--',
      row.bp_values.measurement_dates.value,
      row.count_measurements,
      row.bp_values.bp_morning_average.value,
      row.bp_values.bp_afternoon_average.value,
      row.bp_values.bp_weekly_average.value,
      row.hr_values.hr_morning_afternoon,
      row.hr_values.hr_general_average,
    ],
    // Chart configurations - PSM uses same charts as HTA Protocol
    charts: [
      'hta-general-blood-pressure',
      'hta-general-heart-rate',
      'hta-morning-blood-pressure',
      'hta-morning-heart-rate',
      'hta-afternoon-blood-pressure',
      'hta-afternoon-heart-rate',
    ],
  },

  profileFields: {
    weight: true,
    height: false,
    bmi: false,
    bloodPressure: true,
    heartRate: true,
    ejectionFraction: false,
  },

  alerts: {
    showHowIFeelColumn: false,
    priorityLevels: [1, 2, 3, 4, 5],
  },
};

export default psmConfig;
